import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-description-logo',
  template: `
    <div class="description-logo">
      <span class="description-logo-text">Powered by</span> <img src="assets/images/logo.png" alt="Company logo" width="160" />
    </div>`,
  styleUrls: ['./description-logo.component.scss']
})
export class DescriptionLogoComponent {
}
